export default function Button() {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    height: 'initial',
                },
            },
        },
    };
}
